// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"c4dffe8f","904":"d8c53488"}[chunkId] + ".chunk.js";
};